import * as React from "react";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";

import axiosInstance from "../../Api/Axios";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";
import { useConnectedUser } from "../../Context/ConnectedUserContext";

const initialFormState = {
  phone_number: "",
  phone_number_2: "",
  email: "",
};

const UserInfos = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();
  const { user, updateUser } = useConnectedUser();

  const handleChangeField = (e, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  React.useEffect(() => {
    setValRegister(user || {});
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/client/update-info`, {
        phone_number: valRegister.phone_number,
        phone_number_2: valRegister.phone_number_2,
        email: valRegister.email,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          updateUser(valRegister);

          addToast({
            variant: "success",
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.data || error.response.data.message,
          });
        }
      });
  };

  return (
    <div>
      <h1>Modifier Informations</h1>
      <p>Veuillez remplir les champs ci dessous</p>
      <form className="register-form" onSubmit={handleSubmit} noValidate>
        <Textfield
          autoComplete="off"
          label="Code Client"
          name="client_code"
          type="text"
          placeholder="Code Client"
          size="large"
          value={valRegister.client_code}
          disabled
          onChange={(e) => handleChangeField(e, "client_code")}
          hasError={formErrorMessages.client_code}
          errorMessage={
            formErrorMessages.client_code && (
              <div className="text-danger">{formErrorMessages.client_code}</div>
            )
          }
        />

        <Textfield
          autoComplete="off"
          label="Nom"
          name="name"
          type="text"
          placeholder="Nom"
          size="large"
          value={valRegister.name}
          disabled
          onChange={(e) => handleChangeField(e, "name")}
          hasError={formErrorMessages.name}
          errorMessage={
            formErrorMessages.name && (
              <div className="text-danger">{formErrorMessages.name}</div>
            )
          }
        />
        <Textfield
          autoComplete="off"
          label="Nom de la société"
          name="company_name"
          type="text"
          placeholder="Nom de la société"
          size="large"
          value={valRegister.company_name}
          disabled
          onChange={(e) => handleChangeField(e, "company_name")}
          hasError={formErrorMessages.company_name}
          errorMessage={
            formErrorMessages.company_name && (
              <div className="text-danger">
                {formErrorMessages.company_name}
              </div>
            )
          }
        />

        <Textfield
          autoComplete="off"
          label="Numéro de téléphone"
          name="phone_number"
          type="text"
          placeholder="Veuillez insérer votre numéro de téléphone"
          size="large"
          value={valRegister.phone_number}
          disabled
          onChange={(e) => handleChangeField(e, "phone_number")}
          hasError={formErrorMessages.phone_number}
          errorMessage={
            formErrorMessages.phone_number && (
              <div className="text-danger">
                {formErrorMessages.phone_number}
              </div>
            )
          }
        />

        <Textfield
          autoComplete="off"
          label="Deuxième numéro de téléphone"
          name="phone_number_2"
          type="text"
          placeholder="Veuillez insérer votre deuxième numéro de téléphone"
          size="large"
          value={valRegister.phone_number_2}
          onChange={(e) => handleChangeField(e, "phone_number_2")}
          hasError={formErrorMessages.phone_number_2}
          errorMessage={
            formErrorMessages.phone_number_2 && (
              <div className="text-danger">
                {formErrorMessages.phone_number_2}
              </div>
            )
          }
        />

        <Textfield
          autoComplete="off"
          label="Adresse e-mail"
          name="email"
          type="email"
          placeholder="Veuillez insérer votre adresse e-mail"
          size="large"
          value={valRegister.email}
          disabled
          onChange={(e) => handleChangeField(e, "email")}
          hasError={formErrorMessages.email}
          errorMessage={
            formErrorMessages.email && (
              <div className="text-danger">{formErrorMessages.email}</div>
            )
          }
        />

        <div className="wrap_actions_form">
          <Button type="submit" size="lg">
            Modifier
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UserInfos;
